import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const linkGridFulfillmentFilterToPdpSelector = createSelector(
    testTargetOffersSelector,
    offers => offers.linkGridFulfillmentFilterToPdp || Empty.Object
);

export { linkGridFulfillmentFilterToPdpSelector };
